"use strict"

import React from "react"
import { FormattedMessage } from "react-intl"

import SingleRunView from "../../shared_components/graph_dashboards/SingleRunView"
import MultiRunView from "../../shared_components/graph_dashboards/MultiRunView"
import LiveRunNavigator from "../../shared_components/graph_dashboards/LTPMDash/LiveRunNavigator"
import PageLoadingPanel from "../../shared_components/widgets/PageLoadingPanel"
import { withZoomState } from "../../shared_components/config/ZoomConfigProvider"
import { withWarehouseData } from "../../shared_components/graphing/plotting/RunInfoLoader"
import { withGraphState } from "../../shared_components/config/GraphConfigProvider"

function RunsViewAdaptor(props) {
  const runData = props?.runData?.[props.runs[0]]

  if ((!runData || props.runs.length === 0) && !props.live) {
    return (
      <div className={"no-runs-selected"}>
        <h4 style={{ marginTop: "45px", marginBottom: "45px", textAlign: "center" }}>
          <FormattedMessage id={"graphing.no.runs.selected"} description={"No Runs Selected Message"} />
        </h4>
      </div>
    )
  } else if (props.live) {
    return <LiveRunNavigator {...props} />
  } else if (props.runs.length > 1) {
    return <MultiRunView {...props} />
  } else if (runData.loading) {
    return <PageLoadingPanel />
  } else {
    return <SingleRunView {...props} />
  }
}

export default withGraphState(withZoomState(withWarehouseData(RunsViewAdaptor)))
